import { useBooleanFlagValue } from '@openfeature/react-sdk';

export const BODY_FONT_REFRESH_FLAG_KEY = 'release-body-font-refresh';
export const BODY_FONT_REFRESH_FLAG_DEFAULT = false;

/**
 * Flagsmith rollout gate (default OFF, no manual exposure). ON swaps the body
 * font to General Sans + body weight 450 / tracking 0.005em app-wide via the
 * `body-font-refresh` <html> marker (see globals.css, `BodyFontRefreshMarker`);
 * Exposure headings are unaffected.
 *
 * Design/playbook (decisions, migration, retire): docs/body-font-refresh.md.
 */
export const useIsBodyFontRefreshEnabled = () =>
  useBooleanFlagValue(BODY_FONT_REFRESH_FLAG_KEY, BODY_FONT_REFRESH_FLAG_DEFAULT);
